import { useState } from "react";
import patient from "../../../../assets/img/patient.jpg";
import rightArrow from "../../../../assets/img/arrow-right.svg";
import { useNavigate } from "react-router";
import { showToast, ToastContainer } from "../../../../util/toastHelper";
import { ADMIN_CMS_SOCIAL_MEDIA } from "../../../../action/apiPath";
import { errorMessageCreate } from "../../../../util/custom";
import { ADMINSOCIALMEDIAPAGE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";
import { CallWithAuth } from "../../../../action/apiActions";

const AdminSocialMediaAdd = () => {
    const navigate = useNavigate()
    const [socialMedia, setSocialMedia] = useState({
        platform: "",
        url: "",
        is_active: false
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSocialMedia({ ...socialMedia, [name]: value });
    };

    const handleSubmit = async () => {
        if (!socialMedia.platform) {
            showToast("error", "Platform is required.");
            return;
        }

        if (!socialMedia.url) {
            showToast("error", "URL is required.");
            return;
        }

        try {
            setIsSubmit(true);

            let response = await CallWithAuth("POST", ADMIN_CMS_SOCIAL_MEDIA, socialMedia);

            let message = errorMessageCreate(response?.res?.data?.message);
            if (response?.res?.data?.statusCode === 201) {
                showToast("success", message);
                setTimeout(() => {
                    navigate(`${ADMINSOCIALMEDIAPAGE}`);
                    setIsSubmit(false);
                }, 1000);

            } else {
                let message = errorMessageCreate(response?.res?.data?.message);
                showToast("error", message);
                setIsSubmit(false);
            }
        } catch (err) {
            console.log(err);
            setIsSubmit(false);
        }
    };

    return (
        <div>
            {isLoading && (<Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />)}

            <section class="site_hero patient_management_banner">
                <div class="site_container">
                    <div class="site_row">
                        <div class="txt_colm">
                            <div class="txt_block">
                                <h1>Manage Social Media</h1>
                                <p>Manage each social media efficiently</p>
                            </div>
                        </div>
                        <div class="img_colm">
                            <div class="img_block">
                                <img src={patient} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mycustomclass patient_form_block">
                <div class="site_container">
                    <div class="patient_form">
                        <div className="field_block">
                            <label htmlFor="platform">Platform <span className="text-danger">*</span></label>
                            <select
                                name="platform"
                                value={socialMedia.platform}
                                onChange={handleInputChange}
                            >
                                <option value="">Select Platform</option>
                                <option value="youtube">Youtube</option>
                                <option value="twitter">Twitter</option>
                                <option value="linkedin">Linkedin</option>
                                <option value="facebook">Facebook</option>
                                <option value="instagram">Instagram</option>
                                <option value="tiktok">Tiktok</option>
                            </select>
                        </div>

                        <div className="field_block">
                            <label htmlFor="url">URL <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                name="url"
                                className="text_field"
                                placeholder="Enter URL"
                                value={socialMedia.url}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="field_block">
                            <label htmlFor="is_active">Active?</label>
                            <input
                                type="checkbox"
                                name="is_active"
                                checked={socialMedia.is_active}
                                onChange={(e) => {
                                    setSocialMedia({
                                        ...socialMedia,
                                        ...{ is_active: e.target.checked }
                                    })
                                }}
                            />
                        </div>

                        <div className="field_block">
                            <div className="btn_row">
                                <button disabled={isLoading || isSubmit} onClick={handleSubmit}>
                                    <span>Submit </span> <img src={rightArrow} alt="Arrow" />
                                    {isSubmit && (
                                        <>
                                            {""}
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer />
        </div>
    );
};

export default AdminSocialMediaAdd;
